<div class="row">
  <div class="col-sm-12 col-md-12 col-xl-12">
    <div class="d-flex justify-content-end no-gutters pt-3">
      <button
        class="btn btn-sm btn-default-red"
        data-toggle="collapse"
        data-target="#collapseFilter"
        [disabled]="!app.profile.profiles.length"
        (click)="app.filterList.open = !app.filterList.open"
        [ngClass]="{ btnFilterOpen: app.filterList.open }"
        >
        <i class="fas fa-filter"></i>
        {{ app.text.home.filters }}
        @if (!app.filterList.open) {
          <i class="fal fa-angle-right"></i>
        }
        @if (app.filterList.open) {
          <i class="far fa-times"></i>
        }
      </button>
    </div>
    <div class="row pt-3">
      <div class="col-md-12 pull-right">
        <app-filter-fields></app-filter-fields>
      </div>
    </div>
    <app-paginator
      [length]="app.profile.profiles.length"
      [index]="app.paginator.focus"
      (focus)="app.paginator.focus = $event"
    ></app-paginator>
    <div>
      <div class="tableFixHead">
        <table class="table table-striped spacing-table">
          <thead>
            <tr class="pointer">
              <th class="p-2">No.</th>
              @for (column of app.list.personProfile.columns; track column) {
                <th
                  class="p-2"
                  >
                  <span>
                    {{ app.field.getLabel(column) }}
                  </span>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (
              profile of app.paginator.getPageWithDoc(); track
              profile; let i = $index) {
              <tr
                [ngClass]="{ isSelected: app.isSelected(profile) }"
                (click)="navigateProfile(profile.id)"
                class="pointer"
                >
                <td class="px-2 py-1">{{ i + 1 }}</td>
                @for (column of app.list.personProfile.columns; track column) {
                  <td
                    class="px-2 py-1"
                    >
                    <span>
                      {{ getData(profile, column) }}
                    </span>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <app-paginator
      [length]="app.profile.profiles.length"
      [index]="app.paginator.focus"
      (focus)="app.paginator.focus = $event"
    ></app-paginator>
  </div>
</div>
